import getCurrentRoute from './get-current-route';

export function isSearch(): boolean {
  const currentRoute = getCurrentRoute();
  return currentRoute && currentRoute.indexOf('/search') > -1;
}
